import * as React from 'react'
import { Form } from "react-bootstrap";
import * as _ from 'lodash'

import { FormControlProps } from 'react-bootstrap'

interface InputValidateProps extends FormControlProps {
    pattern?: string
    required?: boolean
    onChangeValue(e): void
    onValidate(value: any): boolean

}

const InputValidate: React.FunctionComponent<InputValidateProps> = (props): JSX.Element => {
    const [validate, setValidate] = React.useState(false);
    const inputRef = React.useRef(null)
    React.useEffect(() => {
        setCustomValidity(props.onValidate(props.value))
    }, [props.value]);


    const setCustomValidity = (isValid) => {
        console.log("value", props.value)
        if (props.required && inputRef && inputRef.current) {
            if (!isValid) {
                console.log("setCustomValidity", false)
                inputRef.current.setCustomValidity("Invalid field.")
            } else {
                console.log("setCustomValidity", true)
                inputRef.current.setCustomValidity("")
            }
        }
    }

    
    return (
        <Form.Control
            {..._.omit(props, ['required', 'pattern', 'onChangeValue', 'onValidate'])}
            ref={inputRef}
            required={props.required}
            pattern={props.pattern}
            isValid={validate && props.onValidate(props.value)}
            isInvalid={validate && !props.onValidate(props.value)}
            onChange={(e) => {

                setCustomValidity(props.onValidate(props.value))

                if (props.onChange) {
                    props.onChange(e)
                }
                let value = e.target.value
                if (props.onChangeValue) {
                    props.onChangeValue(value)
                }
                setValidate(true)
            }} />
    )
}

export default InputValidate;